var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',_vm._g({staticClass:"v-radio-button",class:{
        'v-radio-button--disabled': _vm.disabled,
        'v-radio-button--inline': _vm.inline,
    },attrs:{"disabled":_vm.disabled,"name":_vm.name,"type":"radio"},domProps:{"value":_vm.value}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }